import { downgradeComponent } from '@angular/upgrade/static';
import {
  AccessDeniedComponent,
  SeatLimitComponent,
  NotFoundComponent,
  PlanDowngradeComponent,
} from '@mode/shared/ui-error-pages';

import * as angular from 'angular';

export const DowngradedSharedFeatureErrorPagesModule = angular
  .module('downgraded-shared-feature-error-pages', [])
  .directive('accessDenied', downgradeComponent({ component: AccessDeniedComponent }))
  .directive('modeSeatLimit', downgradeComponent({ component: SeatLimitComponent }))
  .directive('modePlanDowngrade', downgradeComponent({ component: PlanDowngradeComponent }))
  .directive('notFound', downgradeComponent({ component: NotFoundComponent })).name;
